module.exports = "../images/fishing-lodge-3-5.jpg?v=3880db9";